// Bugfix 19 (#1387): een overurenregistratie gaat pas weg als er gekozen is
// tussen Uitbetalen en Omzetten naar vakantie-uren. Zonder keuze blijft het
// formulier staan met een gewone melding bij de keuze, in plaats van een
// browsermelding op een onzichtbaar rondje. De backend controleert hetzelfde.
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["keuze", "melding", "groep"]

  controleer(event) {
    if (this.keuzeTargets.some((keuze) => keuze.checked)) return

    event.preventDefault()
    this.meldingTarget.hidden = false
    this.groepTarget.classList.add("is-fout")
    this.groepTarget.scrollIntoView({ block: "nearest", behavior: "smooth" })
  }

  gekozen() {
    this.meldingTarget.hidden = true
    this.groepTarget.classList.remove("is-fout")
  }
}
